import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, map, Observable, startWith, switchMap, tap } from 'rxjs';
import { BaseComponent } from 'src/app/shared/base/base-component.directive';
import { GpsMarkerService } from '../../services/gps-marker.service';
import * as L from 'leaflet';
import { MapDialogComponent } from '../map.component';
import { VehicleApiService } from 'src/app/shared/api/services/vehicle-api.service';
import { Vehicle } from 'src/app/data/model/vehicle';
import { VehiclesViewService } from '../../services/vehicles-view.service';
import { VehicleSimpleApi } from 'src/app/shared/api/services/vehicle-simple-api';

const Validate: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  if( control.get('start')?.value && control.get('end')?.value){
    const start_date = new Date(control.get('start')?.value);
    const end_date = new Date(control.get('end')?.value);

    if(start_date > end_date){
      return  { 'date_err': true };
    }

    const diff= end_date.getTime() - start_date.getTime()
    if ((diff/(1000*60*60)) > 48) {
      return { 'date-diff': true };
    }
    
  }
  
  return null;
};

@Component({
  standalone: false,
  selector: 'app-map-filter',
  templateUrl: './map-filter.component.html',
  styleUrls: ['./map-filter.component.scss'],
  providers: [GpsMarkerService]
})
export class MapFilterDialogComponent extends BaseComponent implements OnInit {

  filterFormGroup: FormGroup = this.formBuilder.group({
    value: [null, [Validators.required]],
    start: [null, [Validators.required]],
    end: [null, [Validators.required]]
  }, { validator: Validate });

  filteredOptions?:Observable<Vehicle[]>;

  options:Vehicle[]=this.data;

  get selectedField(): FilterField {
    return this.filterFormGroup.value?.field;
  }

  get FieldType(): typeof FieldType {
    return FieldType;
  }
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Vehicle[],//GridFilterParam,
    private dialogRef: MatDialogRef<MapFilterDialogComponent>,
    private formBuilder: FormBuilder,
    private vehicleService: VehicleSimpleApi,
    private service: GpsMarkerService, 
  ) {
    super();
  }

  ngOnInit() {
    this.filteredOptions = this.filterFormGroup.get('value')?.valueChanges.pipe(
      startWith(''),
      map((val: string | Vehicle) => this._filterOptions(val))
    );
  }
  
  group= new L.FeatureGroup();
  addFilter() {
    var vehicle:Vehicle[];
    MapDialogComponent.layer.clearLayers();
    this.filterFormGroup.markAllAsTouched();
    if (this.filterFormGroup.valid) {
      const search_value= this.filterFormGroup.value.value;
      const start_date = this.filterFormGroup.value.start;
      const end_date = this.filterFormGroup.value.end;
      this.service.filterVehiclePoints(this.group, search_value, start_date, end_date);
      vehicle=this.options?.filter((option:Vehicle) =>
        option?.licenseplate.toUpperCase()==this.filterFormGroup.value.value);
      MapDialogComponent.data=vehicle[0];
      this.dialogRef.close();
    };
    this.group.addTo(MapDialogComponent.layer);
  }

  setVehicleData(data:Vehicle){
    var vehicle_data:Vehicle=data;  
    return vehicle_data
  }

  private _filterOptions(value: string | Vehicle): Vehicle[] {
      if (typeof value === 'string') {
        const search = value.toUpperCase();
        

        const localResults = this.options?.filter((list:any) =>
          list.licenseplate.toUpperCase().includes(search)
        ) || [];

        if (localResults.length > 0) {
          return localResults;
        } else {
          if (!this.options) {
            this.options = [];
          }
          this.vehicleService.getWithFilter({"plate":value.toLocaleUpperCase(), "limit": "6", "offset": "0"}).subscribe((res) => {
            if (res.results && res.results.length > 0) {
              // Update local cache
              this.options = [...(this.options || []), ...res.results];
            }
          });
          return this.options;
        }
      }
    
      return [];
    }


  displayFn() {
    return (groupId: string) =>
      (this.options?.find((item:any) => item.licenseplate === groupId)?.licenseplate) ?? '';
  }
}


export type GridFilterParam = {
  fields: FilterField[];
};

export type FilterField = {
  name: string;
  text: string;
  type: FieldType;
  options?: Observable<FilterFieldOption[]>;
};


export enum FieldType {
  TEXT,
  AUTOCOMPLETE,
  DATETIME
}

export type FilterFieldOption = { licenseplate: string; plate: string };
